import { render, staticRenderFns } from "./DomainNameInput.vue?vue&type=template&id=0c5df468&scoped=true"
import script from "./DomainNameInput.vue?vue&type=script&lang=js"
export * from "./DomainNameInput.vue?vue&type=script&lang=js"
import style0 from "./DomainNameInput.vue?vue&type=style&index=0&id=0c5df468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5df468",
  null
  
)

export default component.exports